import React from 'react';
import { Route, Routes } from 'react-router-dom';

import HeaderSecondary from '@components/HeaderSecondary';

import CancerQuoteBuyNewPage from './CancerQuoteBuyNewPage';
import CancerQuoteReviewPage from './CancerQuoteReviewPage';
import CancerQuoteBuyEditPage from './CancerQuoteBuyEditPage';
import CancerQuoteBuyCustomPage from './CancerQuoteBuyCustomPage';

const CancerQuoteBuyRoute = () => {
  return (
    <>
      <HeaderSecondary />
      <Routes>
        <Route path="/*" element={<CancerQuoteBuyNewPage />} />
        <Route path=":orderNumber/edit/*" element={<CancerQuoteBuyEditPage />} />
        <Route path=":orderNumber/review" element={<CancerQuoteReviewPage />} />
        <Route path=":orderNumber/custom" element={<CancerQuoteBuyCustomPage />} />
      </Routes>
    </>
  );
};

export { CancerQuoteBuyRoute };
